import React, { useState, useRef, useEffect } from 'react';
import './ShareJobDropdown.css';

const SITE_URL = 'https://sechire.net';
// eslint-disable-next-line no-unused-vars
const COMPANY_URL = 'https://securelayer7.net';
const BLOG_URL = 'https://blog.securelayer7.net';

// ── Real blog posts from blog.securelayer7.net, organized by category ──

const BLOGS = {
  pentest: [
    { title: 'Firewall Penetration Testing: Strengthen Your Network Security', url: `${BLOG_URL}/firewall-penetration-testing/` },
    { title: 'Internal vs External Penetration Testing: Key Differences', url: `${BLOG_URL}/internal-vs-external-penetration-testing/` },
    { title: 'Understanding Penetration Testing Rules of Engagement', url: `${BLOG_URL}/understanding-penetration-testing-rules-of-engagement/` },
    { title: 'DAST vs Penetration Testing: Key Differences and How to Choose', url: `${BLOG_URL}/dast-vs-penetration-testing/` },
    { title: 'Autonomous Pentesting: How AI is Changing Offensive Security', url: `${BLOG_URL}/autonomous-pentesting-ai-changing-offensive-security/` },
    { title: 'Top 15 Penetration Testing Service Companies in USA', url: `${BLOG_URL}/top-penetration-testing-service-companies-in-usa/` },
    { title: 'Top 10 VAPT Companies in India for 2026', url: `${BLOG_URL}/top-vapt-companies-in-india/` },
    { title: 'Top 10 Penetration Testing Service Companies in India 2026', url: `${BLOG_URL}/top-penetration-testing-service-companies-in-india/` },
    { title: 'Metasploitable3 Walkthrough: Penetration Testing (Part 1)', url: `${BLOG_URL}/metasploitable3-walkthrough-penetration-testing-part-1/` },
  ],
  redteam: [
    { title: 'Red Team Rules of Engagement: Scope, Limits and Practices', url: `${BLOG_URL}/red-team-rules-of-engagement/` },
    { title: 'Effective Recon Techniques for Red Teaming Engagements', url: `${BLOG_URL}/effective-recon-techniques-for-red-teaming-engagements/` },
    { title: 'Advanced Persistent Threat (APT): Detection & Protection Guide', url: `${BLOG_URL}/advanced-persistent-threat/` },
    { title: 'Cyber Kill Chain Explained: Framework, Stages, and Strategies', url: `${BLOG_URL}/cyber-kill-chain-explained/` },
    { title: 'Social Engineering: What It Is, Types & Prevention Best Practices', url: `${BLOG_URL}/social-engineering/` },
  ],
  appsec: [
    { title: 'OWASP API Top 10: Risks & Prevention Strategies', url: `${BLOG_URL}/owasp-api-top-10-risks/` },
    { title: 'OWASP Top 10 Security Risks: A Detailed Guide (Updated 2025)', url: `${BLOG_URL}/owasp-top-10-security-risks/` },
    { title: 'OWASP A01: Broken Access Control Risks, Examples & Prevention', url: `${BLOG_URL}/owasp-a01-broken-access-control/` },
    { title: 'Shadow APIs Explained: Risks, Detection, and Prevention', url: `${BLOG_URL}/shadow-apis-explained/` },
    { title: 'API Security Checklist: Expert Tips And Practices', url: `${BLOG_URL}/api-security-checklist/` },
    { title: 'Strengthening API Security by Mitigating OWASP Top 10 API Vulnerabilities', url: `${BLOG_URL}/strengthening-api-security/` },
    { title: 'OWASP A03: Software Supply Chain Failures Explained', url: `${BLOG_URL}/software-supply-chain-failures/` },
    { title: 'Eliminating Race Conditions in APIs through Synchronized Code Execution', url: `${BLOG_URL}/eliminating-race-conditions-in-apis/` },
    { title: 'SAST vs DAST: Key Differences in Application Security', url: `${BLOG_URL}/sast-vs-dast/` },
    { title: 'Top 12 API Security Companies: Reviews, Pros And Cons', url: `${BLOG_URL}/top-api-security-companies/` },
    { title: 'API Authentication: Common Methods, Best Practices & Tools', url: `${BLOG_URL}/api-authentication/` },
  ],
  sourcecode: [
    { title: 'OWASP A03: Software Supply Chain Failures Explained', url: `${BLOG_URL}/software-supply-chain-failures/` },
    { title: 'RBAC Explained: Benefits, Models, and Best Practices Guide', url: `${BLOG_URL}/role-based-access-control/` },
    { title: 'SAST vs DAST: Key Differences in Application Security', url: `${BLOG_URL}/sast-vs-dast/` },
    { title: 'Understanding Remote Code Execution: Types, Risks & Prevention', url: `${BLOG_URL}/understanding-remote-code-execution/` },
    { title: 'CVE-2025-55182: React Critical Prototype Pollution Vulnerability', url: `${BLOG_URL}/cve-2025-55182-react-prototype-pollution/` },
  ],
  cloud: [
    { title: 'Enabling IMDSv2: Strengthen Modern EC2 Security Effortlessly', url: `${BLOG_URL}/enabling-imdsv2-ec2-security/` },
    { title: 'How to Strengthen Cloud App Security with Resource Isolation', url: `${BLOG_URL}/strengthen-cloud-app-security-resource-isolation/` },
    { title: 'Enhancing Data Security with KMS Encryption in S3 Buckets', url: `${BLOG_URL}/kms-encryption-s3-buckets/` },
    { title: 'Enhancing AWS Security: Restricting S3 Wildcard Actions in IAM Policies', url: `${BLOG_URL}/restricting-s3-wildcard-actions-iam/` },
    { title: 'Securing Kubernetes Clusters with Role-Based Policies', url: `${BLOG_URL}/securing-kubernetes-clusters-rbac/` },
    { title: 'Securing Your Cloud Environment: Mitigating Cross-Account IAM Risks', url: `${BLOG_URL}/mitigating-cross-account-iam-risks/` },
    { title: 'DoD Cloud Security Requirements: Complete Compliance Guide', url: `${BLOG_URL}/dod-cloud-security-requirements/` },
  ],
  ai: [
    { title: 'MCP Server Pentest: Securing the AI "USB-C" for File and API Access', url: `${BLOG_URL}/mcp-server-pentest/` },
    { title: 'AI Agent Exploit Test: Securing Browser & Desktop Models', url: `${BLOG_URL}/ai-agent-exploit-test/` },
    { title: 'AI Agent Framework Security: LangChain, LangGraph, CrewAI & More', url: `${BLOG_URL}/ai-agent-framework-security/` },
    { title: 'AI Attack Surface Review: Mapping and Securing the Whole Stack', url: `${BLOG_URL}/ai-attack-surface-review/` },
    { title: 'AI Business Logic Abuse Testing: Guarding Against Prompt Risks', url: `${BLOG_URL}/ai-business-logic-abuse-testing/` },
    { title: 'AI App Pentest: Securing LLM-Powered Applications', url: `${BLOG_URL}/ai-app-pentest/` },
    { title: 'Model Context Protocol Security (MCP): An Essential Guide', url: `${BLOG_URL}/model-context-protocol-security/` },
    { title: 'Anthropic AI Misuse by Chinese Hackers: How to Defend LLMs', url: `${BLOG_URL}/anthropic-ai-misuse-defend-llms/` },
    { title: 'Understanding LLMjacking: A Complete Guide', url: `${BLOG_URL}/understanding-llmjacking/` },
    { title: 'AI Agents for Offensive Security: Redefining Threat Detection', url: `${BLOG_URL}/ai-agents-for-offensive-security/` },
    { title: 'A Guide to Generative AI Security Risks And Best Practices', url: `${BLOG_URL}/generative-ai-security-risks/` },
  ],
  iot: [
    { title: 'Electron Research in Desktop Apps [Part 1]', url: `${BLOG_URL}/electron-research-in-desktop-apps/` },
    { title: 'Backdoor Attack: Types, Examples, And Prevention', url: `${BLOG_URL}/backdoor-attack/` },
    { title: 'Enumeration Attack in Cybersecurity: Risks, Tools, and Prevention', url: `${BLOG_URL}/enumeration-attack/` },
  ],
  network: [
    { title: 'Firewall Penetration Testing: Strengthen Your Network Security', url: `${BLOG_URL}/firewall-penetration-testing/` },
    { title: 'OSI Model: 7 Layers, Key Functions, Security Risks & Attacks', url: `${BLOG_URL}/osi-model/` },
    { title: 'DNS Zone Transfer Penetration Testing: Uncovering Hidden Risks', url: `${BLOG_URL}/dns-zone-transfer-penetration-testing/` },
    { title: 'Defending Against Man-in-the-Middle Attacks with Network Segmentation', url: `${BLOG_URL}/man-in-the-middle-attacks-network-segmentation/` },
    { title: 'Active Directory Attacks and Preventive Measures', url: `${BLOG_URL}/active-directory-attacks/` },
    { title: 'Enhancing Network Security: Restricting Open SSH Access in Security Groups', url: `${BLOG_URL}/restricting-open-ssh-access-security-groups/` },
  ],
  mobile: [
    { title: 'OWASP M9: Insecure Data Storage in Mobile Apps', url: `${BLOG_URL}/owasp-m9-insecure-data-storage/` },
    { title: 'OWASP M8: Security Misconfiguration Demystified', url: `${BLOG_URL}/owasp-m8-security-misconfiguration/` },
    { title: 'OWASP M5: Insecure Communication Explained', url: `${BLOG_URL}/owasp-m5-insecure-communication/` },
    { title: 'OWASP M4: Insufficient Input/Output Validation Risk Decoded', url: `${BLOG_URL}/owasp-m4-insufficient-input-output-validation/` },
    { title: 'OWASP M7: Insufficient Binary Protection Risks Explained', url: `${BLOG_URL}/owasp-m7-insufficient-binary-protection/` },
    { title: 'OWASP M6: Inadequate Privacy Controls Explained', url: `${BLOG_URL}/owasp-m6-inadequate-privacy-controls/` },
    { title: 'OWASP M3: Understanding Insecure Authentication', url: `${BLOG_URL}/owasp-m3-insecure-authentication/` },
    { title: 'OWASP M1: Understanding Improper Credential Usage Risk', url: `${BLOG_URL}/owasp-m1-improper-credential-usage/` },
    { title: 'Enhancing Mobile API Security through JWT Token Expiry Management', url: `${BLOG_URL}/mobile-api-security-jwt-token-expiry/` },
  ],
  cve: [
    { title: 'CVE-2026-25049: n8n Remote Code Execution (Critical, CVSS 9.4)', url: `${BLOG_URL}/cve-2026-25049/` },
    { title: 'CVE-2025-68613: n8n RCE via Expression Injection', url: `${BLOG_URL}/n8n-cve-2025-68613-rce/` },
    { title: 'CVE-2025-49127: Kafbat UI RCE via JMX Unsafe Deserialization', url: `${BLOG_URL}/cve-2025-49127-kafbat-ui-rce/` },
    { title: 'CVE-2025-32433: Pre-Auth RCE in Erlang SSH', url: `${BLOG_URL}/cve-2025-32433-erlang-ssh-rce/` },
    { title: 'CVE-2025-25364: Speedify VPN MacOS Privilege Escalation', url: `${BLOG_URL}/cve-2025-25364-speedify-vpn/` },
    { title: 'CVE-2025-1094: PostgreSQL 14.15 SQL Injection', url: `${BLOG_URL}/cve-2025-1094-postgresql/` },
    { title: 'CVE-2025-4318: RCE in AWS Amplify Studio', url: `${BLOG_URL}/cve-2025-4318-aws-amplify-rce/` },
    { title: 'CVE-2025-55182: React Critical Prototype Pollution', url: `${BLOG_URL}/cve-2025-55182-react-prototype-pollution/` },
    { title: 'CVE-2025-2783: Chrome Sandbox Escape via Mojo IPC', url: `${BLOG_URL}/cve-2025-2783-chrome-sandbox-escape/` },
    { title: 'CVE-2025-6019: Linux Privilege Escalation via udisksd', url: `${BLOG_URL}/cve-2025-6019-linux-privilege-escalation/` },
    { title: 'XWiki Critical Vulnerabilities: Complete Security Analysis 2025', url: `${BLOG_URL}/xwiki-critical-vulnerabilities/` },
  ],
  culture: [
    { title: 'A Pentesting Journey with SecureLayer7: An Experience of a Lifetime', url: `${BLOG_URL}/a-pentesting-journey-with-securelayer7-an-experience-of-a-lifetime/` },
    { title: 'Third Time\'s The Charm: How I Got Into SecureLayer7', url: `${BLOG_URL}/third-attempt-and-i-am-finally-a-security-consultant-at-securelayer7/` },
    { title: 'CyberSecurity Internship to Employee... The Journey', url: `${BLOG_URL}/cybersecurity-internship-to-employee/` },
    { title: 'Beginning for the Search of Cybersecurity Jobs Ended at SL7', url: `${BLOG_URL}/beginning-for-the-search-of-cybersecurity-jobs-ended-at-sl7/` },
    { title: 'Working with SecureLayer7 Turned Out to Be a Sapient Journey', url: `${BLOG_URL}/working-with-securelayer7-turned-out-to-be-a-sapient-journey/` },
    { title: 'Black Hat USA 2025 – Strengthening Our Vision', url: `${BLOG_URL}/black-hat-usa-2025/` },
  ],
  general: [
    { title: 'Autonomous Pentesting: How AI is Changing Offensive Security', url: `${BLOG_URL}/autonomous-pentesting-ai-changing-offensive-security/` },
    { title: 'OWASP Top 10 Security Risks: A Detailed Guide', url: `${BLOG_URL}/owasp-top-10-security-risks/` },
    { title: 'Top 10 Offensive Security Companies in India (Updated 2026)', url: `${BLOG_URL}/top-offensive-security-companies-in-india/` },
    { title: 'Decoding Pentest Findings: Accept or Reject? – Webinar Recap', url: `${BLOG_URL}/decoding-pentest-findings/` },
    { title: 'CTEM Explained: Continuous Threat Exposure Management', url: `${BLOG_URL}/continuous-threat-exposure-management/` },
    { title: 'An Introduction to Zero Day Attacks', url: `${BLOG_URL}/zero-day-attacks/` },
  ],
};

function pickRandom(arr, count) {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

// ── Post variants per category (multiple hooks for rotation) ──

function getPostVariants(job) {
  const title = (job.title || '').toLowerCase();
  const dept = (job.department || '').toLowerCase(); // eslint-disable-line no-unused-vars
  const jobUrl = `${SITE_URL}/jobs/${job.slug || job._id}`;
  const company = job.company || 'SecureLayer7';
  const loc = job.location || '';
  const locTag = loc ? ` in ${loc}` : '';

  // Red Team / Offensive Security
  if (title.includes('red team') || title.includes('offensive')) {
    return {
      category: 'redteam',
      blogCategories: ['redteam', 'cve', 'pentest'],
      variants: [
        `Stop. Before you scroll past this — when was the last time you broke into a Fortune 500 company's network... and got paid for it?

That's Tuesday at ${company}.

Our Red Team has conducted 25+ real-world attack simulations and identified 40,000+ critical vulnerabilities. We don't run automated scans and call it a day. We think like adversaries.

Now we're looking for a ${job.title}${locTag} who wants to do the same.

Think you're ready? Prove it.

Apply: ${jobUrl}

Read how our team operates:`,
        `"We got in through a misconfigured S3 bucket, pivoted through Active Directory, and had domain admin in 4 hours."

That's not a war story from a breach. That's a typical Red Team engagement at ${company}.

We're hiring a ${job.title}${locTag}. If your idea of fun is chaining exploits and writing custom C2 frameworks — this is your team.

We've published CVEs, presented at Black Hat, and secured infrastructure across 30+ countries.

Apply here: ${jobUrl}

Our research:`,
        `Most companies find bugs. We simulate nation-state attacks.

${company}'s Red Team doesn't just find vulnerabilities — we prove exploitation paths that boards take seriously. 25+ engagements. 40,000+ critical findings. Real adversary emulation.

We're hiring a ${job.title}${locTag}.

If you've ever written a phishing campaign that bypassed an EDR, or chained 3 low-severity bugs into domain admin — we should talk.

Apply: ${jobUrl}

Behind the scenes:`,
      ]
    };
  }

  // Penetration Testing / Security Consultant
  if (title.includes('security consultant') || title.includes('pentest') || title.includes('penetration') || title.includes('cybersecurity expert')) {
    return {
      category: 'pentest',
      blogCategories: ['pentest', 'appsec', 'cve'],
      variants: [
        `What if your job was to hack into companies — and get paid for it?

At ${company}, our Security Consultants conduct research-led penetration testing across web apps, APIs, cloud infrastructure, and networks.

We've secured 20,000+ assets across 30+ countries. We've found bugs that SAST/DAST tools missed entirely.

We're hiring a ${job.title}${locTag}. No two days are the same. Every project is a new puzzle.

Apply: ${jobUrl}

Read what our team has published:`,
        `Here's a number that should keep CISOs up at night: 40,000+ critical vulnerabilities.

That's what ${company}'s team has found — through manual, research-led penetration testing. Not automated scans. Real hacking.

We're growing the team. Looking for a ${job.title}${locTag} who can find what scanners can't.

You'll work on everything from startup MVPs to enterprise platforms across 30+ countries.

Apply now: ${jobUrl}

Some of our recent work:`,
        `Every time we test an application, we find something the automated tools missed.

That's not a marketing claim — it's the reality of research-led penetration testing at ${company}. Our consultants go deep: business logic flaws, chained vulnerabilities, race conditions that only surface under real-world conditions.

We're hiring a ${job.title}${locTag}.

If you've ever found an IDOR that exposed 100K records, or chained an SSRF to RCE — you'll fit right in.

Apply: ${jobUrl}

Our research & insights:`,
      ]
    };
  }

  // Source Code Review / SAST
  if (title.includes('source code') || title.includes('code review') || title.includes('sast')) {
    return {
      category: 'sourcecode',
      blogCategories: ['sourcecode', 'appsec', 'cve'],
      variants: [
        `Reading code is one thing. Finding the vulnerability hiding in 500K lines of Java? That's another skill entirely.

${company}'s Source Code Review team goes line-by-line through enterprise codebases to uncover security flaws that automated scanners miss.

Deserialization bugs. IDOR patterns buried in middleware. Auth bypasses hidden in helper functions.

We're hiring a ${job.title}${locTag}. If you read code like a detective reads a crime scene — this is your role.

Apply: ${jobUrl}

Related research from our team:`,
        `SAST tools flag 1,000 findings. 950 are false positives. The 50 real ones? They often miss those too.

That's why ${company} does manual source code review. Our team reads through enterprise codebases — Java, Python, Go, .NET — finding the vulnerabilities that matter.

We're looking for a ${job.title}${locTag} who can spot a prototype pollution in JavaScript or an unsafe deserialization in C#.

Apply: ${jobUrl}

Relevant reads:`,
      ]
    };
  }

  // Cloud Security
  if (title.includes('cloud') || title.includes('aws') || title.includes('azure') || title.includes('devops') || title.includes('devsecops')) {
    return {
      category: 'cloud',
      blogCategories: ['cloud', 'appsec', 'cve'],
      variants: [
        `"An S3 bucket was public for 6 months. Nobody noticed — except the attacker."

Cloud misconfigurations cause 80% of security breaches. At ${company}, we find them before attackers do.

Our cloud security team tests AWS, Azure, and GCP infrastructure through research-led penetration testing — not just config audits.

We're hiring a ${job.title}${locTag}.

Apply: ${jobUrl}

Our cloud security research:`,
        `IMDSv1 is still enabled. IAM roles have wildcard permissions. KMS encryption is off on half the S3 buckets.

Sound familiar? These are real findings from ${company}'s cloud penetration tests.

We're looking for a ${job.title}${locTag} who can find the gaps in complex multi-cloud environments that automated scanners can't catch.

Apply here: ${jobUrl}

Deep dives from our team:`,
        `Kubernetes RBAC misconfigs. Cross-account IAM escalation. Unencrypted EBS volumes.

These aren't theoretical risks — they're findings from ${company}'s cloud penetration tests across Fortune 500 environments.

We're hiring a ${job.title}${locTag} to join our cloud security practice. If you can chain an SSRF to steal instance metadata and pivot to production — you're exactly who we need.

Apply: ${jobUrl}

Our research:`,
      ]
    };
  }

  // IoT / Hardware / Embedded
  if (title.includes('iot') || title.includes('hardware') || title.includes('embedded') || title.includes('firmware')) {
    return {
      category: 'iot',
      blogCategories: ['iot', 'network', 'cve'],
      variants: [
        `IoT devices are everywhere — and most of them are shockingly insecure.

At ${company}, our IoT Security team has tested everything from smart locks to industrial control systems. Firmware extraction. JTAG debugging. RF protocol analysis.

We've found vulnerabilities in devices that "passed" certification.

We're hiring a ${job.title}${locTag}. If you own a soldering iron and a software-defined radio — we should talk.

Apply: ${jobUrl}

Related research:`,
        `Most security teams test web apps. We test the hardware they run on.

${company}'s IoT security practice goes deep: firmware reverse engineering, side-channel attacks, BLE/Zigbee protocol analysis, and SCADA testing.

We're looking for a ${job.title}${locTag} who's comfortable with both IDA Pro and a multimeter.

Apply: ${jobUrl}

Explore our work:`,
      ]
    };
  }

  // AI / LLM / ML Security
  if (title.includes('ai') || title.includes('llm') || title.includes('machine learning') || title.includes('ml security')) {
    return {
      category: 'ai',
      blogCategories: ['ai', 'appsec', 'cve'],
      variants: [
        `LLMs and AI systems introduce attack surfaces that didn't exist 2 years ago.

Prompt injection. Tool-use exploitation. MCP server compromise. Data poisoning. Model extraction.

At ${company}, we've built an AI Security Assessment practice that tests production AI systems the way adversaries would attack them.

We're hiring a ${job.title}${locTag}. If you've exploited an AI agent or found a way to exfiltrate training data — let's talk.

Apply: ${jobUrl}

Our AI security research (published):`,
        `Chinese hackers used Anthropic's Claude for intelligence operations. A prompt injection in a banking chatbot moved $50K.

AI security isn't theoretical anymore. At ${company}, our team conducts adversarial testing on production LLMs, AI agents, and MCP-connected systems.

We're hiring a ${job.title}${locTag}. This is the cutting edge of offensive security.

Apply: ${jobUrl}

Read our AI security research:`,
        `We pentested an AI agent that had file system access, API keys, and browser automation. It took 3 prompts to make it exfiltrate credentials.

That's the kind of work ${company}'s AI Security team does every day. MCP server testing. LangChain/CrewAI framework audits. Agentic workflow exploitation.

We're hiring a ${job.title}${locTag}.

Apply: ${jobUrl}

Dive deeper:`,
      ]
    };
  }

  // Manager / Lead / Director
  if (title.includes('manager') || title.includes('lead') || title.includes('director') || title.includes('head of') || title.includes('vp')) {
    return {
      category: 'general',
      blogCategories: ['general', 'culture', 'pentest'],
      variants: [
        `Building a world-class cybersecurity team isn't about hiring the most hackers. It's about building a culture where research, rigor, and curiosity drive everything.

${company} has secured 1,000+ clients. Identified 40,000+ critical vulnerabilities. Presented at Black Hat. Published CVEs that made headlines.

We're looking for a ${job.title}${locTag} to lead our next phase of growth.

If you've built security teams that ship real impact — this is your opportunity.

Apply: ${jobUrl}

About our work:`,
        `1,000+ clients. 30+ countries. 40,000+ critical vulnerabilities found. Zero breaches for our clients.

${company} is scaling — and we need leaders who can take our research-led approach to the next level.

We're hiring a ${job.title}${locTag}. You'll lead a team of elite security consultants and shape the future of PTaaS.

Apply: ${jobUrl}

Our track record:`,
      ]
    };
  }

  // Intern / Fresher / Trainee / Junior
  if (title.includes('intern') || title.includes('fresher') || title.includes('trainee') || title.includes('junior') || title.includes('entry')) {
    return {
      category: 'culture',
      blogCategories: ['culture', 'pentest', 'cve'],
      variants: [
        `Want to start your cybersecurity career at a company that has published real CVEs, presented at Black Hat, and secured assets in 30+ countries?

${company} isn't your average security firm. We do research-led penetration testing, build autonomous pentester software (BugDazz), and our team has found 40,000+ critical vulnerabilities.

We're hiring a ${job.title}${locTag}.

If you've done CTFs, bug bounties, or spent nights on HackTheBox — this is where your career starts for real.

Apply: ${jobUrl}

Hear from people who started here:`,
        `"I applied 3 times before I got in. Best decision I ever made."

That's a real story from a ${company} security consultant who started as an intern. Now they test Fortune 500 companies.

We're hiring a ${job.title}${locTag}. We don't need a perfect resume — we need curiosity, hunger, and a passion for breaking things (ethically).

Apply: ${jobUrl}

Read their stories:`,
        `Most internships = making coffee and watching someone else work.

At ${company}, interns work on real penetration testing engagements from week 1. You'll learn from researchers who've published CVEs and presented at Black Hat USA.

We're hiring a ${job.title}${locTag}.

Bring your curiosity. We'll teach you the rest.

Apply: ${jobUrl}

Life at SecureLayer7:`,
      ]
    };
  }

  // Network / Infrastructure Security
  if (title.includes('network') || title.includes('infrastructure') || title.includes('soc') || title.includes('security analyst')) {
    return {
      category: 'network',
      blogCategories: ['network', 'pentest', 'cve'],
      variants: [
        `Network perimeters are dissolving. But network security has never mattered more.

At ${company}, our team conducts comprehensive internal and external penetration tests — AD exploitation, lateral movement, firewall bypasses, and network segmentation testing.

We're hiring a ${job.title}${locTag}. If you can go from a foothold to domain admin and write a report that makes the CISO take action — you're our person.

Apply: ${jobUrl}

Our network security research:`,
        `Active Directory. Misconfigured firewalls. Open SSH in security groups. Flat networks with no segmentation.

These aren't textbook scenarios — they're findings from ${company}'s network penetration tests across enterprise environments.

We're hiring a ${job.title}${locTag}.

Apply: ${jobUrl}

Deep dives:`,
      ]
    };
  }

  // Project Manager / Engagement Manager
  if (title.includes('project manager') || title.includes('engagement manager') || title.includes('delivery')) {
    return {
      category: 'general',
      blogCategories: ['general', 'culture'],
      variants: [
        `Great security outcomes need great project leadership.

At ${company}, we run 1,000+ security engagements across 30+ countries. Every engagement is different — different scope, different stack, different risk profile.

Our project managers are the bridge between technical brilliance and client success.

We're hiring a ${job.title}${locTag}. If you can manage complex technical projects and keep clients happy — this role is for you.

Apply: ${jobUrl}

About us:`,
      ]
    };
  }

  // Mobile Security
  if (title.includes('mobile') || title.includes('android') || title.includes('ios')) {
    return {
      category: 'mobile',
      blogCategories: ['mobile', 'appsec', 'cve'],
      variants: [
        `Most mobile apps store credentials in plaintext. Most security teams never check.

At ${company}, our mobile security practice tests Android and iOS applications for everything OWASP Mobile Top 10 covers — and everything it doesn't.

Insecure data storage. Broken authentication. Inadequate binary protection. Certificate pinning bypasses.

We're hiring a ${job.title}${locTag}.

Apply: ${jobUrl}

Our mobile security research:`,
        `We found an app storing JWT tokens in SharedPreferences. Another had its API key hardcoded in the APK. A third had no certificate pinning at all.

These are real findings from ${company}'s mobile penetration tests.

We're hiring a ${job.title}${locTag}. If you can reverse-engineer an APK, bypass root detection, and find business logic flaws in mobile APIs — apply now.

Apply: ${jobUrl}

Read more:`,
      ]
    };
  }

  // Default / Generic (still compelling)
  return {
    category: 'general',
    blogCategories: ['general', 'culture', 'cve'],
    variants: [
      `${company} is not your average cybersecurity company.

We do research-led penetration testing. We build autonomous pentester software (BugDazz). We've published CVEs that made the news. Our team has secured assets across 30+ countries.

And we're hiring.

Open role: ${job.title}${locTag}

If you're passionate about cybersecurity and want to work on challenges that actually matter — this is the place.

Apply: ${jobUrl}

Learn about our work:`,
      `40,000+ critical vulnerabilities found. 1,000+ clients secured. 30+ countries served. Published CVEs. Black Hat presentations.

That's ${company} in numbers.

Now we're growing, and looking for a ${job.title}${locTag}.

Whether you're an experienced professional or someone who eats, sleeps, and breathes security — we want to hear from you.

Apply: ${jobUrl}

What we do:`,
      `Most cybersecurity companies sell fear. We sell proof.

${company} is a research-led offensive security company. We find the vulnerabilities that others miss — through manual penetration testing, source code review, and AI security assessments.

We're hiring a ${job.title}${locTag}.

Apply: ${jobUrl}

Our research speaks for itself:`,
    ]
  };
}

function getShareContent(job) {
  const data = getPostVariants(job);
  const variantIndex = Math.floor(Math.random() * data.variants.length);
  const post = data.variants[variantIndex];

  const allBlogs = [];
  data.blogCategories.forEach(cat => {
    if (BLOGS[cat]) allBlogs.push(...BLOGS[cat]);
  });

  const uniqueBlogs = allBlogs.filter((b, i, arr) =>
    arr.findIndex(x => x.url === b.url) === i
  );
  const blogs = pickRandom(uniqueBlogs, 3);

  const blogLinks = blogs.map(b => `${b.title}: ${b.url}`).join('\n');
  const fullPost = post + '\n' + blogLinks + '\n\n#CyberSecurity #Hiring #InfoSec #SecureLayer7 #OffensiveSecurity';

  return { post: fullPost, blogs, variantIndex, totalVariants: data.variants.length };
}

const ShareJobDropdown = ({ job, compact = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [copiedPost, setCopiedPost] = useState(false);
  const [content, setContent] = useState(null);
  const [toastMessage, setToastMessage] = useState('');
  const dropdownRef = useRef(null);

  const jobUrl = `${SITE_URL}/jobs/${job.slug || job._id}`;
  // OG endpoint serves crawler-friendly metadata for social previews
  const socialPreviewUrl = `${SITE_URL}/api/jobs/${job.slug || job._id}/og`;

  useEffect(() => {
    if (isOpen && !content) {
      setContent(getShareContent(job));
    }
  }, [isOpen, job, content]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const regeneratePost = () => {
    setContent(getShareContent(job));
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    }
  };

  const showToast = (msg) => { // eslint-disable-line no-unused-vars
    setToastMessage(msg);
    setTimeout(() => setToastMessage(''), 2500);
  };

  const handleCopyLink = async () => {
    await copyToClipboard(jobUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopyPost = async () => {
    if (!content) return;
    await copyToClipboard(content.post);
    setCopiedPost(true);
    setTimeout(() => setCopiedPost(false), 2000);
  };

  const handleShareLinkedIn = async () => {
    if (!content) return;
    await copyToClipboard(content.post);
    const linkedInText = `${content.post}\n\n${socialPreviewUrl}`;
    const linkedInUrl = `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(linkedInText)}`;
    window.open(linkedInUrl, '_blank', 'width=700,height=700,noopener,noreferrer');
    setIsOpen(false);
  };

  const handleShareTwitter = async () => {
    if (!content) return;
    const tweetText = content.post.substring(0, 260);
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(socialPreviewUrl)}`,
      '_blank', 'width=600,height=500,noopener,noreferrer'
    );
    setIsOpen(false);
  };

  const handleShareFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(socialPreviewUrl)}`,
      '_blank', 'width=600,height=500,noopener,noreferrer'
    );
    setIsOpen(false);
  };

  const handleShareWhatsApp = () => {
    if (!content) return;
    const waText = `${content.post.substring(0, 760)}\n\n${socialPreviewUrl}`;
    window.open(
      `https://wa.me/?text=${encodeURIComponent(waText)}`,
      '_blank', 'noopener,noreferrer'
    );
    setIsOpen(false);
  };

  const handleShareEmail = () => {
    if (!content) return;
    const subject = `${job.title} at ${job.company || 'SecureLayer7'} — Apply Now`;
    const body = `${content.post}\n\nApply here: ${jobUrl}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setIsOpen(false);
  };

  const shareButtons = [
    {
      name: 'LinkedIn',
      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#0A66C2"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
      onClick: handleShareLinkedIn,
      highlight: true,
    },
    {
      name: 'Twitter / X',
      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#000"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
      onClick: handleShareTwitter,
    },
    {
      name: 'WhatsApp',
      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>,
      onClick: handleShareWhatsApp,
    },
    {
      name: 'Facebook',
      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>,
      onClick: handleShareFacebook,
    },
    {
      name: 'Email',
      icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#6B7280"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>,
      onClick: handleShareEmail,
    },
  ];

  return (
    <div className="share-dropdown-container" ref={dropdownRef}>
      <button
        className={`share-trigger-btn ${compact ? 'compact' : ''}`}
        onClick={() => {
          if (!isOpen) setContent(getShareContent(job));
          setIsOpen(!isOpen);
        }}
        title="Share job posting"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
        <span>{compact ? 'Share Link' : 'Share'}</span>
      </button>

      {isOpen && content && (
        <div className="share-dropdown-menu share-dropdown-wide">
          {/* Toast notification */}
          {toastMessage && (
            <div className="share-toast">{toastMessage}</div>
          )}

          <div className="share-dropdown-header">
            <span>Share: {job.title}</span>
          </div>

          {/* Pre-written post with full preview */}
          <div className="share-post-preview">
            <div className="share-post-label">
              <span>Ready-to-post content</span>
              <div className="share-post-actions">
                <button
                  type="button"
                  className="share-regenerate-btn"
                  onClick={regeneratePost}
                  title="Generate a different post"
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
                    <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
                  </svg>
                </button>
                <button
                  className={`share-copy-btn ${copiedPost ? 'copied' : ''}`}
                  onClick={handleCopyPost}
                >
                  {copiedPost ? 'Copied!' : 'Copy Post'}
                </button>
              </div>
            </div>
            <div className="share-post-text-full">
              {content.post}
            </div>
          </div>

          {/* Relevant blog links */}
          {content.blogs.length > 0 && (
            <div className="share-blogs">
              <div className="share-blogs-label">Included blog links (from blog.securelayer7.net):</div>
              {content.blogs.map((blog, i) => (
                <a
                  key={i}
                  href={blog.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="share-blog-link"
                  onClick={(e) => e.stopPropagation()}
                >
                  <span className="share-blog-title">{blog.title}</span>
                  <span className="share-blog-arrow">→</span>
                </a>
              ))}
            </div>
          )}

          {/* Job link */}
          <div className="share-link-preview">
            <span className="share-link-url">{jobUrl}</span>
            <button
              className={`share-copy-btn ${copied ? 'copied' : ''}`}
              onClick={handleCopyLink}
            >
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
          </div>

          {/* Share buttons — LinkedIn highlighted */}
          <div className="share-social-grid">
            {shareButtons.map((btn) => (
              <button
                key={btn.name}
                className={`share-social-btn ${btn.highlight ? 'share-social-highlight' : ''}`}
                onClick={btn.onClick}
                title={btn.name === 'LinkedIn' ? 'Open LinkedIn with post pre-filled' : `Share on ${btn.name}`}
              >
                <span className="share-social-icon">{btn.icon}</span>
                <span className="share-social-name">
                  {btn.name}
                  {btn.name === 'LinkedIn' && <span className="share-social-hint">opens with post pre-filled</span>}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareJobDropdown;
